"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _user = require('redux/actions/user');

var _BaseForm2 = require('components/BaseForm');

var _BaseForm3 = _interopRequireDefault(_BaseForm2);

var _modal = require('redux/actions/modal');

var _voice_code = require('redux/actions/voice_code');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmChangePhone = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        error: state.user.error,
        errorCode: state.user.errorCode,
        preload: state.user.preload,
        changeWithCode: state.user.changeWithCode,
        user: state.user,
        profile: state.auth.user,
        lang: state.lang
    };
}, { changePhoneWithCode: _user.changePhoneWithCode, resetError: _user.resetError, resetVoiceCode: _voice_code.resetVoiceCode, hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
    (0, _inherits3.default)(ConfirmChangePhone, _BaseForm);

    function ConfirmChangePhone(props, context) {
        (0, _classCallCheck3.default)(this, ConfirmChangePhone);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmChangePhone.__proto__ || (0, _getPrototypeOf2.default)(ConfirmChangePhone)).call(this, props, context));

        _this.handlerChangeInput = function (event) {
            _this.setState({
                sms: event.target.value
            });
        };

        _this.showOuterAlert = function (alert) {
            _this.setState({ outerAlert: alert });
        };

        _this.state = {
            sms: '',
            outerAlert: null
        };
        return _this;
    }

    (0, _createClass3.default)(ConfirmChangePhone, [{
        key: 'onSubmit',
        value: function onSubmit(event) {
            (0, _get3.default)(ConfirmChangePhone.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfirmChangePhone.prototype), 'onSubmit', this).call(this, event);

            if (this.isValid()) {
                this.props.changePhoneWithCode(this.props.pipoId, this.props.newPhone, this.state.sms);
                this.props.resetError();
                this.props.resetVoiceCode();
                this.setState({
                    sms: ''
                });
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var changeWithCode = this.props.changeWithCode;


            if (changeWithCode !== nextProps.changeWithCode && nextProps.changeWithCode) {
                this.props.hide();
                setTimeout(function () {
                    _reactSAlert2.default.success(_this2.props.succesOperationText, { position: 'top-right', effect: 'slide', timeout: 5000 });
                }, 1000);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetError();
            this.props.resetVoiceCode();
        }

        /**
         * Валидация по всем методам проверки
         *
         * @returns {boolean}
         */

    }, {
        key: 'isValid',
        value: function isValid() {
            return this.state.sms.length > 0;
        }
    }, {
        key: 'getLogin',
        value: function getLogin() {
            var profile = this.props.profile;


            return profile.confirmed.confirmed_email ? profile.email : profile.confirmed.confirmed_phone ? profile.phone : profile.phone ? profile.phone : profile.email;
        }

        /**
         * Получение номера телефона пользователя
         * @returns {*}
         */

    }, {
        key: 'getUserPhone',
        value: function getUserPhone() {
            var phone = this.props.profile.phone;
            return phone ? phone : this.props.newPhone;
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('ConfirmChangePhone', null, { folderName: "ConfirmChangePhone" });

            return _react2.default.createElement(View, {
                sms: this.state.sms,
                onSubmit: this.onSubmit,
                disabledSubmit: !this.isValid(),
                preload: this.props.preload,
                error: this.props.error,
                onChange: this.handlerChangeInput,
                showOuterAlert: this.showOuterAlert,
                outerAlert: this.state.outerAlert,
                login: this.getLogin(),
                phone: this.getUserPhone(),
                errorCode: this.props.errorCode,
                lang: this.props.lang
            });
        }
    }]);
    return ConfirmChangePhone;
}(_BaseForm3.default), _class2.propTypes = {
    lang: _react.PropTypes.object
}, _temp)) || _class);
exports.default = ConfirmChangePhone;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmChangePhone/ConfirmChangePhone.jsx
// module id = 1643
// module chunks = 0